import React from "react";

import { Button } from "@material-ui/core";
import { isSubmitButtonEnabled } from "common/utils/utility";

export const CommonButton = ({
  onClick,
  isSubmitting,
  values,
  errors,
  touched,
  text,
  className,
  disabled,
  ...props
}: any) => (
  <Button
    {...props}
    disabled={
      disabled ||
      !isSubmitButtonEnabled(touched, errors, Object.keys(values)) ||
      isSubmitting
    }
    variant="contained"
    onClick={onClick}
    className={className}
  >
    {text}
  </Button>
);
